import { createRef } from 'react';

export const RootAuthProvider = createRef();

export function loginOut() {
  if (RootAuthProvider && RootAuthProvider.current) {
    let oRootAuthComp: any = RootAuthProvider.current;
    oRootAuthComp._refLogout();
  }
}
